import { render, staticRenderFns } from "./Product_Details_New.vue?vue&type=template&id=60a2b84c"
import script from "./Product_Details_New.vue?vue&type=script&lang=js"
export * from "./Product_Details_New.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports